"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultRegistry = void 0;
const json_crdt_patch_1 = require("../../../json-crdt-patch");
const constants_1 = require("../slice/constants");
const SliceBehavior_1 = require("./SliceBehavior");
const SliceRegistry_1 = require("./SliceRegistry");
/**
 * Creates a new slice registry with common tag registered.
 */
const createDefaultRegistry = () => {
    const undefSchema = json_crdt_patch_1.s.con(undefined);
    const registry = new SliceRegistry_1.SliceRegistry();
    //----------------------------- Inline elements with "One" stacking behavior
    const i0 = (tag, name, fromHtml) => {
        registry.add(new SliceBehavior_1.SliceBehavior(constants_1.SliceStacking.One, tag, name, void 0, false, void 0, fromHtml));
    };
    const i1 = (tag, name, htmlTags) => {
        const fromHtml = {};
        for (const htmlTag of htmlTags)
            fromHtml[htmlTag] = () => [tag, null];
        i0(tag, name, fromHtml);
    };
    i1(-6 /* TAG.i */, 'Italic', ['i', 'em']);
    i1(-3 /* TAG.b */, 'Bold', ['b', 'strong']);
    i1(-12 /* TAG.s */, 'Strikethrough', ['s', 'strike']);
    i0(-9 /* TAG.u */, 'Underline');
    i0(-15 /* TAG.code */, 'Code');
    i0(-16 /* TAG.mark */, 'Highlight');
    i0(-33 /* TAG.kbd */, 'Keyboard');
    i0(-22 /* TAG.del */, 'Delete');
    i0(-23 /* TAG.ins */, 'Insert');
    i0(-24 /* TAG.sup */, 'Superscript');
    i0(-25 /* TAG.sub */, 'Subscript');
    i0(-27 /* TAG.math */, 'Math');
    // -------------------------- Inline elements with "Atomic" stacking behavior
    const a0 = (tag, name) => {
        registry.add(new SliceBehavior_1.SliceBehavior(constants_1.SliceStacking.Atomic, tag, name));
    };
    a0(-40 /* TAG.iembed */, 'Inline Embed');
    // --------------------------- Inline elements with "Many" stacking behavior
    const aSchema = json_crdt_patch_1.s.obj({}, {
        href: json_crdt_patch_1.s.str(''),
        title: json_crdt_patch_1.s.str(''),
    });
    registry.add(new SliceBehavior_1.SliceBehavior(constants_1.SliceStacking.Many, -17 /* TAG.a */, 'Link', aSchema, false, void 0, {
        a: (jsonml) => {
            const attr = jsonml[1] || {};
            const data = {
                href: attr.href ?? '',
                title: attr.title ?? '',
            };
            return [-17 /* TAG.a */, { data, inline: true }];
        },
    }));
    // const colSchema = s.obj(
    //   {},
    //   {
    //     col: s.str<string>(''),
    //   },
    // );
    // registry.add(
    //   new SliceBehavior(SliceStacking.Many, TAG.col, 'Color', colSchema, false, void 0, {
    //     col: (jsonml) => {
    //       const attr = jsonml[1] || {};
    //       const data: JsonNodeView<SchemaToJsonNode<typeof colSchema>> = {
    //         col: attr.col ?? '',
    //       };
    //       return [TAG.col, {data, inline: true}] as PeritextMlElement<TAG.col, any, true>;
    //     },
    //   }),
    // );
    // TODO: add more default annotations with "Many" stacking behavior
    // comment = SliceTypeCon.comment,
    // font = SliceTypeCon.font,
    // col = SliceTypeCon.col,
    // bg = SliceTypeCon.bg,
    // hidden = SliceTypeCon.hidden,
    // footnote = SliceTypeCon.footnote,
    // ref = SliceTypeCon.ref,
    // iaside = SliceTypeCon.iaside,
    // iembed = SliceTypeCon.iembed,
    // bookmark = SliceTypeCon.bookmark,
    // -------------------------- Block elements with "Marker" stacking behavior
    const commonBlockSchema = json_crdt_patch_1.s.obj({}, {
        indent: json_crdt_patch_1.s.con(0),
        align: json_crdt_patch_1.s.str('left'),
    });
    const b0 = (tag, name, container) => {
        registry.add(new SliceBehavior_1.SliceBehavior(constants_1.SliceStacking.Marker, tag, name, commonBlockSchema, container));
    };
    b0(0 /* TAG.p */, 'Paragraph', false);
    b0(1 /* TAG.blockquote */, 'Blockquote', true);
    b0(2 /* TAG.codeblock */, 'Code block', false);
    b0(5 /* TAG.pre */, 'Pre-formatted', false);
    b0(6 /* TAG.ul */, 'Unordered list', true);
    b0(7 /* TAG.ol */, 'Ordered list', true);
    b0(8 /* TAG.tl */, 'Task list', true);
    b0(9 /* TAG.li */, 'List item', true);
    b0(11 /* TAG.h1 */, 'Heading 1', false);
    b0(12 /* TAG.h2 */, 'Heading 2', false);
    b0(13 /* TAG.h3 */, 'Heading 3', false);
    b0(14 /* TAG.h4 */, 'Heading 4', false);
    b0(15 /* TAG.h5 */, 'Heading 5', false);
    b0(16 /* TAG.h6 */, 'Heading 6', false);
    b0(19 /* TAG.title */, 'Title', false);
    b0(20 /* TAG.subtitle */, 'Subtitle', false);
    // b0(TAG.br, false);
    // b0(TAG.nl, false);
    // b0(TAG.hr, false);
    // b0(TAG.page, false);
    // b0(TAG.aside, true);
    // b0(TAG.embed, false);
    // b0(TAG.column, true);
    // b0(TAG.contents, true);
    // b0(TAG.table, true);
    // b0(TAG.row, true);
    // b0(TAG.cell, true);
    // b0(TAG.collapselist, true);
    // b0(TAG.collapse, true);
    // b0(TAG.note, true);
    // b0(TAG.mathblock, false);
    return registry;
};
exports.createDefaultRegistry = createDefaultRegistry;
